export default __webpack_public_path__ + "static/media/212-mark.239ba9a7.svg";